/*
 * @Author       : 程哲林
 * @Date         : 2021-11-29 13:54:00
 * @LastEditors  : 程哲林
 * @LastEditTime : 2024-03-12 11:00:53
 * @FilePath     : /marketing-introduce-ssr/utils/sensors.ts
 * @Description  : 未添加文件描述
 */

import queryString from 'querystring';

import { isBrowser } from '@/common/const';
import { getAppVersion, getCurrPlatformText, reportError } from '@/utils';

const sensors = isBrowser ? require('@woulsl-tools/sensors').default : {};

function getPresetProperties() {
  const baseData = sensors?.getPresetProperties();
  delete baseData._distinct_id;
  return baseData;
}

function urlQuery() {
  return queryString.parse(window.location.search.replace(/^\?/, '')) || {};
}

function channelSlice(channel: string | string[] | null) {
  try {
    if (!channel) {
      return {};
    }
    const channelStr = Array.isArray(channel) ? channel[0] : channel;

    const systemArr = channelStr.replace(/-.*$/, '').split('_');

    return {
      business_ownership: systemArr[0],
      channel_name: systemArr[1],
      service_provider: systemArr[2],
      custom_state: systemArr[3]
    };
  } catch (e) {
    reportError(e);
  }

  return {};
}

const getSensData = async () => {
  try {
    const appVersion = getAppVersion();
    const platform = await getCurrPlatformText();
    const baseData = {
      custom_platform: platform,
      $app_version: appVersion || ''
    };

    if (localStorage && typeof localStorage.getItem === 'function') {
      const val = localStorage.getItem('sensData_yy');
      return val
        ? {
            ...JSON.parse(val),
            ...baseData
          }
        : baseData;
    }
    return baseData;
  } catch (e) {
    reportError(e);
  }

  return {};
};

export const saveSensData = (data: any) => {
  try {
    if (localStorage && typeof localStorage.setItem === 'function') {
      localStorage.setItem('sensData_yy', JSON.stringify(data));
    }
  } catch (e) {
    reportError(e);
  }
};

export const sensClickInitiative = async (val: any = {}) => {
  try {
    const values = val || {};
    const parsed = urlQuery();
    const channel = parsed.channel || '';
    const channelNo = values?.channelNo || parsed.channelNo || '';

    if (values?.channelNo) {
      delete values.channelNo;
    }

    if (values?.material_ids?.length) {
      values.material_ids = values.material_ids?.toString().split(',');
    }

    sensors?.track('$WebClick', {
      ...getPresetProperties(),
      url_id: parsed.linkId || '',
      ...(await getSensData()),
      channel,
      channel_no: channelNo,
      ...values
    });
  } catch (e) {
    reportError(e);
  }
};

export const sensClick = (e: any) => {
  try {
    // e.persist();
    const ele = e.currentTarget as HTMLElement;
    const newValues: any = {};
    for (const [key, val] of Object.entries(ele.dataset)) {
      if (key.includes('element')) {
        newValues[`$${key}`] = val;
      } else if (key === 'material_ids') {
        newValues[key] = val?.toString().split(',');
      } else {
        newValues[key] = val;
      }
    }
    sensClickInitiative(newValues);
  } catch (err) {
    reportError(err);
  }
};

let timer: any = null;
export const sensAutoTrack = (val = {}) => {
  try {
    const values: any = val || {};
    const parsed = urlQuery();
    const channel = parsed.channel || '';
    const channelNo = values?.channelNo || parsed.channelNo || '';

    if (values?.channelNo) {
      delete values.channelNo;
    }
    if (values?.material_ids?.length) {
      values.material_ids = values.material_ids?.toString().split(',');
    }
    clearTimeout(timer);
    timer = setTimeout(async () => {
      window?.sensors?.quick('autoTrack', {
        activity_id: parsed.actId || '',
        channel,
        channel_no: channelNo,
        ...channelSlice(channel),
        ...(await getSensData()),
        ...values
      });

      timer = null;
    }, 150);
  } catch (e) {
    reportError(e);
  }
};

export const sensElementView = async (val = {}) => {
  try {
    const values: any = val || {};
    const parsed = urlQuery();
    const channel = parsed.channel || '';
    const channelNo = values?.channelNo || parsed.channelNo || '';
    const baseData = await getSensData();

    if (values?.channelNo) {
      delete values.channelNo;
    }
    if (values?.material_ids?.length) {
      values.material_ids = values.material_ids?.toString().split(',');
    }

    sensors?.track('ElementView', {
      ...baseData,
      activity_id: parsed.actId || baseData.activity_id || '',
      channel,
      channel_no: channelNo,
      ...values
    });
  } catch (e) {
    reportError(e);
  }
};

export const sensPageView = async (val = {}) => {
  try {
    const values: any = val || {};
    const parsed = urlQuery();
    const channel = parsed.channel || '';
    const channelNo = values?.channelNo || parsed.channelNo || '';
    if (values?.channelNo) {
      delete values.channelNo;
    }
    if (values?.material_ids?.length) {
      values.material_ids = values.material_ids?.toString().split(',');
    }

    const baseData = await getSensData();

    sensors?.track('$pageview', {
      ...baseData,
      activity_id: parsed.actId || baseData.activity_id || '',
      channel,
      channel_no: channelNo,
      ...values
    });
  } catch (e) {
    reportError(e);
  }
};
export const sensVideoPlayStart = async (values = {}) => {
  try {
    const parsed = urlQuery();
    const channel = parsed.channel || '';

    const baseData = await getSensData();
    sensors?.track('VideoPlayStart', {
      ...baseData,
      activity_id: parsed.actId || baseData.activity_id || '',
      channel,
      ...values
    });
  } catch (e) {
    reportError(e);
  }
};

export const sensVideoPlayFinish = async (values = {}) => {
  try {
    const parsed = urlQuery();
    const channel = parsed.channel || '';

    const baseData = await getSensData();

    sensors?.track('VideoPlayFinish', {
      ...baseData,
      activity_id: parsed.actId || baseData.activity_id || '',
      channel,
      ...values
    });
  } catch (e) {
    reportError(e);
  }
};

/**
 * 通用神策上报
 */
export const sensorsTrack = (event: string, data: Record<string, any>) => {
  if (window?.sensors) {
    window.sensors.quick('isReady', () => {
      if (event === 'autoTrack') {
        window.sensors.quick('autoTrack', {
          ...data
        });
      } else if (event === '$WebClick') {
        // 手动webclick上报丢失默认参数问题补全，补全参数只取$开头参数
        const resetDefaultParams: any = {};
        const defaultParams = (window.sensors as any).getPresetProperties() || {};
        const defaultParamsKey = Object.keys(defaultParams);
        for (let i = 0; i < defaultParamsKey.length; i++) {
          const item = defaultParamsKey[i];
          if (item && item.match(/^\$/)) {
            resetDefaultParams[item] = defaultParams[item];
          }
        }
        const params = {
          ...resetDefaultParams,
          ...data
        };
        window.sensors.track(event, {
          ...params
        });
      } else {
        window.sensors.track(event, {
          ...data
        });
      }
    });
  }
};
